import React, { useEffect, useState, useRef } from "react";
import "./FeatureMatrix.css"; // Import styling

const FeatureMatrix = () => {
    const [features, setFeatures] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const tableRef = useRef(null); // ✅ Reference for scrolling

    useEffect(() => {
        const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "";
        fetch(`${API_BASE_URL}/api/features`)        
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to load feature matrix");
                }
                return response.json();
            })
            .then((data) => {
                setFeatures(data);
                setLoading(false);
                // ✅ Scroll to the leftmost part of the table after data loads
                setTimeout(() => {
                    if (tableRef.current) {
                        tableRef.current.scrollLeft = 0;
                    }
                }, 100);
            })
            .catch((error) => {
                setError(error.message);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <p className="loading-message">Loading feature matrix...</p>;
    }

    if (error) {
        return <p className="error-message">Error: {error}</p>;
    }

    if (features.length === 0) {
        return <p className="empty-message">No data available.</p>;
    }

    // Extract column names dynamically (subscription plans)
    const plans = Object.keys(features[0]).filter(col => col !== "feature");

    return (
        <div className="feature-matrix-container">
            <h1 className="matrix-title">Compare Our Subscription Plans</h1>
            <div ref={tableRef} className="table-wrapper"> {/* ✅ Scrollable container */}
                <table className="feature-table">
                    <thead>
                        <tr>
                            <th className="sticky-feature">Features</th> {/* ✅ Feature labels always visible */}
                            {plans.map((plan, index) => (
                                <th key={index} className="plan-header">{plan}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {features.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className="sticky-feature">{row.feature || "Unknown Feature"}</td> {/* ✅ Keeps row labels visible */}
                                {plans.map((plan, colIndex) => (
                                    <td key={colIndex} className="feature-value">{row[plan] || "❌"}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );    
};

export default FeatureMatrix;